import { render } from "./ActionSendDocuments.vue?vue&type=template&id=6d7aa960&scoped=true"
import script from "./ActionSendDocuments.vue?vue&type=script&lang=js"
export * from "./ActionSendDocuments.vue?vue&type=script&lang=js"

import "./ActionSendDocuments.vue?vue&type=style&index=0&id=6d7aa960&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7aa960"]])

export default __exports__